<template>
  <div class="NoticeList">
    <navigator title="园区通知列表"></navigator>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="content">
        <div class="noticeItem" v-for="(item, index) in noticList" :key="index" @click="signin(item.noticeId)">
          <div class="title textOver">{{item.noticeTitle}}</div>
          <div class="date">{{item.createTime | DateFilter}}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return{
      noticList: [],
      pageIndex: 1,
      loading: false,
      finished: false,
      total: 0,
    }
  },
  methods: {
    signin(id) {
      this.$router.push({ path: `/notice/${id}` });
    },
    getNewsList() {  // 获取通知列表
      this.$http.post(`${this.URL_PREFIX}/app/get/park/notice/list`, {
        parkId: this.currentParkId,
        currPage: this.pageIndex,
        pageRows: 8,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.noticList = this.noticList.concat(tempArr);
          this.finished = this.noticList.length >= this.total ? true : false;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    loadMore() {
      if (this.noticList.length >= this.total) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getNewsList();
    },
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  created() {
    this.getNewsList();
  },
}
</script>
<style lang="scss" scoped>
  @import "~@scss";
.content{
  .noticeItem{
    background-color: #fff;
    border-bottom: 1px solid #f9f9f9;
    padding: px2rem(30) px2rem(24);
    .title{
      font-size: px2rem(30);
      color: #333;
    }
    .date{
      font-size: px2rem(24);
      color: #666;
      margin-top: px2rem(20);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/notice/NoticeList.vue